export const ALL_PERMISSIONS = [
    { key: 'competition:create',          label: 'Create competitions',          icon: 'bi-trophy' },
    { key: 'competition:edit',            label: 'Edit competitions',            icon: 'bi-pencil' },
    { key: 'teams:manage',               label: 'Manage teams',                 icon: 'bi-people' },
    { key: 'activities:writeAny',         label: 'Edit any activity',            icon: 'bi-pencil-square' },
    { key: 'activities:handleExemptions', label: 'Handle exemption requests',    icon: 'bi-check-circle' },
    { key: 'users:editProfile',           label: 'Edit any profile',             icon: 'bi-person-gear' },
    { key: 'users:viewPermissions',       label: 'View user permissions',        icon: 'bi-eye' },
    { key: 'users:managePermissions',     label: 'Manage user permissions',      icon: 'bi-shield-lock' },
    { key: 'strava:resync',               label: 'Resync Strava activities',     icon: 'bi-arrow-clockwise' },
    { key: 'strava:viewAthletes',         label: 'View connected Strava athletes', icon: 'bi-person-lines-fill' },
];
